module.exports = __webpack_public_path__ + "static/media/cce_logo.30dcbb41.png";